import Images from "@/assets/images";
import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet, width } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import { FontFamilies, Typography } from "@/constants/Typography";
import { SCREEN_WIDTH } from "@/constants/Sizes";

export default function WelcomeSlide1() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>Demand refunds from major brands.</Text>
      {/* Empty icon row */}
      <Image source={Images.subscriptionBanner} style={styles.cardImage} />
      {/* User review */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv2} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @michelleldevlin - &quot;They make it so simple! Took me about 15
            mins to file 6 claims - $600 worth!&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 32,
  },
  cardImage: {
    width: "100%",
    aspectRatio: 16 / 9,
    marginBottom: 32,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#E7E7E733",
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  reviewContent: {
    flex: 1,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    ...Typography.body.medium,
  },
});
